var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClockRoundedGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#EBFBFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 45C39.1797 45 45 39.1797 45 32C45 24.8203 39.1797 19 32 19C24.8203 19 19 24.8203 19 32C19 39.1797 24.8203 45 32 45ZM33 24.4164C33 23.8641 32.5523 23.4164 32 23.4164C31.4477 23.4164 31 23.8641 31 24.4164V33.0831V33.4973L31.2929 33.7902L36.1679 38.6652C36.5584 39.0557 37.1916 39.0557 37.5821 38.6652C37.9726 38.2746 37.9726 37.6415 37.5821 37.251L33 32.6688V24.4164Z",
    fill: "#18A7B7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockRoundedGreen);
export default __webpack_public_path__ + "static/media/clock-rounded-green.84ff4900fda375509f512f611ea4827d.svg";
export { ForwardRef as ReactComponent };